import { Navigate, Route, Routes, useParams } from 'react-router-dom'
import { Layout } from './components/Layout'
import { isLocale } from './content'
import { faq } from './faq'
import { ScrollToTop, usePageMeta } from './lib'
import { pageFaq } from './seo'
import HomePage from './pages/HomePage'
import { FaqPage, GuidePage, GuidesHub, VillePage, VillesHub } from './pages/SeoPages'
import { ConditionsPage, CookiesPage, PlanPage, AboutPage, ContactPage, LegalPage, ProcessPage, QuotePage, ServiceDetailPage, ServicesPage } from './pages/Pages'

function LocalizedSite() {
  const { locale: localeParam } = useParams()
  if (!isLocale(localeParam)) return <Navigate to="/fr" replace />
  const locale = localeParam
  return <Layout locale={locale}>
    <Routes>
      <Route index element={<HomeRoute locale={locale} />} />
      <Route path="services" element={<ServicesPage locale={locale} />} />
      <Route path="services/:slug" element={<ServiceDetailPage locale={locale} />} />
      <Route path="a-propos" element={<AboutPage locale={locale} />} />
      <Route path="comment-ca-fonctionne" element={<ProcessPage locale={locale} />} />
      <Route path="demander-un-devis" element={<QuotePage locale={locale} />} />
      <Route path="contact" element={<ContactPage locale={locale} />} />
      <Route path="conditions-utilisation" element={<ConditionsPage locale={locale} />} />
      <Route path="cookies" element={<CookiesPage locale={locale} />} />
      <Route path="plan-du-site" element={<PlanPage locale={locale} />} />
      <Route path="faq" element={<FaqPage locale={locale} />} />
      <Route path="transitaire-maroc" element={<VillesHub locale={locale} />} />
      <Route path="guides" element={<GuidesHub locale={locale} />} />
      <Route path="guides/:slug" element={<GuidePage locale={locale} />} />
      <Route path=":slug" element={<VillePage locale={locale} />} />
      <Route path="mentions-legales" element={<LegalPage locale={locale} />} />
      <Route path="confidentialite" element={<LegalPage locale={locale} privacy />} />
      <Route path="*" element={<Navigate to={`/${locale}`} replace />} />
    </Routes>
  </Layout>
}

function HomeRoute({ locale }: { locale: 'fr' | 'ar' }) {
  usePageMeta(locale === 'fr' ? 'Transitaire à Casablanca : transit et dédouanement au Maroc' : 'العبور والتخليص الجمركي بالدار البيضاء والمغرب', locale === 'fr' ? 'COGETRANS, transitaire à Casablanca depuis 2003 : dédouanement, import, export, fret maritime, aérien et routier partout au Maroc. Devis sur demande.' : 'كوجيترانس، شركة عبور بالدار البيضاء منذ 2003: التخليص الجمركي، الاستيراد والتصدير، الشحن البحري والجوي والطرقي في جميع أنحاء المغرب.', locale, [pageFaq(faq[locale].slice(0, 6))])
  return <HomePage locale={locale} />
}

export default function App() {
  return <>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Navigate to="/fr" replace />} />
      <Route path="/:locale/*" element={<LocalizedSite />} />
    </Routes>
  </>
}
